'use client';

import { c as _c } from "react/compiler-runtime";
import '@app/_src/layout/navigation.css';
import { LayoutRestrictedBackground } from '@app/registration/(with-padding)/_components/layoutRestrictedBackground';
import { useSetNavigationGestures } from '@app/_common/useSetNavigationGestures';
import { MinimalFooter } from '@app/_src/layout/MinimalFooter';
import css from '@app/_src/layout/RegistrationLayout.module.css';
import { Paper } from '@internations/ds';
import { PropsWithChildren, ReactElement } from 'react';
export default function RegistrationLayout(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  useSetNavigationGestures(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LayoutRestrictedBackground />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Paper className={css.mainContainer}>{children}</Paper>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MinimalFooter />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className={css.layoutRestricted}>{t1}{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}